import { lazy } from 'react';

export const componentResolver = {
  page: lazy(() => import('./src/templates/page')),
  landing_page: lazy(() => import('./src/templates/locations')),
};
